const $ = require("jquery");
const utils = require("../utils.js");

function baseOnload() {

    // Fields for webinar form
    $('#Number_of_Servers__c option').eq(0).text('No. of VMware hosts');
    $('#LearnAboutVeeam__c option').eq(0).text('How did you learn about Veeam?');


    // Forms
    // $('.lpeRegForm').appendTo('#formhere');
    $('span.formSpan').has('.lpeRegForm').appendTo('#formhere');
    $('span.formSpan').has('.mktoForm').appendTo('#formhere');


    // Removing style attribut from Form 2.0
    setTimeout(function () {
        $('.mktoForm').removeAttr('style');
        $('form[id^="mktoForm_"],.lpeRegForm').prepend($('.formTitle').css('position', 'static'));
        $('footer').siblings('form').remove(); //Remove duplicate form on the end of document
    }, 500);

    // Murkup for pop up

    $('<div class="modal fade" id="Modal" tabindex="-1" role="dialog" aria-labelledby="ModalLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button><div class="modal-body"></div></div></div></div>').prependTo('#mktContent');

    // Form
    $('.trigger_form').click(function (e) {
        e.preventDefault();
        $('.modal-body').removeClass('modal-video').contents().remove();
        if ($('.modal-body').has('form')) {
            $('.modal-body').addClass('red-form');
        }
        $('.trigger_form').attr('data-toggle', 'modal').attr('data-target', '#Modal');
        $('span.formSpan').has('.mktoForm').appendTo('.modal-body');
        $('span.formSpan').has('.lpeRegForm').clone().appendTo('.modal-body');
        $('form.mForm').clone().appendTo('.modal-body');
    });

    $('.close, .modal').click(function () {
        $('span.formSpan').has('.mktoForm').appendTo('#formhere');
    });

    $('.modal-body').click(function (e) {
        e.stopPropagation();
    });



    // Video
    $('.trigger_video').click(function (e) {
        e.preventDefault();
        $('.trigger_video').attr('data-toggle', 'modal').attr('data-target', '#Modal');

        if ($('.modal-body').has('iframe')) {
            $('.modal-body').addClass('modal-video');
        }

        if ($(this).attr('href').indexOf('youtu') >= 0) {
            $('<iframe src="https://www.youtube.com/embed/' + utils.parseYoutube($(this).attr('href')) + '" frameborder="0" allowfullscreen></iframe>').appendTo('.modal-body');
        }

        if ($(this).attr('href').indexOf('vimeo.com') >= 0) {

            url = $(this).attr('href');
            var regExp = /https:\/\/(www\.)?vimeo.com\/(\d+)($|\/)/;
            var match = url.match(regExp);
            var id = match[2];

            $('<iframe src="https://player.vimeo.com/video/' + id + '" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>').appendTo('.modal-body');
        }

        $('.close, .modal').click(function () {
            $('.modal-body').removeClass('modal-video').removeClass('red-form').contents().remove();
        });

    });

    // Html

    $('.modal_html').hide();

    $('.trigger_html').click(function (e) {
        e.preventDefault();
        $('.modal-body').removeClass('modal-video').contents().remove();
        var modal_html = $('.modal_html').html();
        $('.modal-body').append(modal_html);
        $('.trigger_html').attr('data-toggle', 'modal').attr('data-target', '#Modal');
    });


    /* New checkbox, 09/2016 */

    if ($('form').hasClass('mktoForm')) {

        MktoForms2.whenReady(function (form) {
            $('div.mktoFormRow:has(input[type="checkbox"])').each(function () {
                $(this).find('label.mktoLabel div.mktoAsterix').remove();
                var labelText = $(this).find('label.mktoLabel').html();
                $(this).find('input[type="checkbox"] + label').html(labelText);
            });
        });

    }

    // Appending black footer
    setTimeout(function () {
        if ($('#footerBlack').length > 0) {
            var footer_links = $('#footer-links').html();
            $('footer').html('<div class="container-fluid blackFooter"><div class="container"><div class="row"><div class="col-xs-12 col-md-3 no-padding" id="copy"><p>Copyright © <span class="year">2015</span> Veeam<sup>®</sup> Software.</p></div><div class="col-xs-12 col-md-5 no-padding" id="Black_footer_links"></div><div class="col-xs-12 col-md-4 no-padding" id="contacts"><div><a href="https://twitter.com/Veeam" target="_blank" class="social tw">Twitter</a><a href="https://www.facebook.com/VeeamSoftware" target="_blank" class="social fb">Facebook</a><a href="http://www.youtube.com/YouVeeam" target="_blank" class="social youtube">Youtube</a><a href="http://www.linkedin.com/companies/veeam-software" target="_blank" class="social li">Linkedin</a></div></div></div></div></div>');
            $('#Black_footer_links').append(footer_links);
            $('#Black_footer_links').append('<a href="https://www.veeam.com/veeamlive.html" target="_blank">Veeam Live</a>');
        }
    }, 600);

}

module.exports = {
    baseOnload
};



// WEBPACK FOOTER //
// ./src/modules/base.js